import * as React from 'react';
import { IconChevronRight16, IconButton, IconPin16, UIText1 } from '@cian/ui-kit';
import { LocationSwitcher } from '../../../cian/location_switcher/location_switcher';
import { TMobileLocationSwitcherProps } from './container';
import * as styles from './index.css';
import { ICity } from '../../../../store/geo';
import { DEFAULT_CITY_REGIONS_IDS } from '../../../../utils/geo';

interface IMobileLocationSwitcherState {
  isPopupOpen: boolean;
}

export class MobileLocationSwitcher extends React.Component<
  TMobileLocationSwitcherProps,
  IMobileLocationSwitcherState
> {
  public state = {
    isPopupOpen: false,
  };

  public render() {
    const { geo, refreshRegions, fetchRegionsCities, filtersCleared } = this.props;
    const { isPopupOpen } = this.state;
    const { selectedCity, selectedRegion } = geo;

    const selectedLocationName =
      (selectedCity && (selectedCity.displayName || selectedCity.fullName)) ||
      (selectedRegion && (selectedRegion.displayName || selectedRegion.fullName));

    return (
      <>
        <div className={styles['button']} onClick={this.handlePopupOpen}>
          <div className={styles['pin-icon']}>
            <IconPin16 color="white_100" />
          </div>
          <div className={styles['title']}>
            <UIText1>{selectedLocationName}</UIText1>
          </div>
          <IconButton icon={<IconChevronRight16 display="block" />} />
        </div>
        <LocationSwitcher
          filtersCleared={filtersCleared}
          isPopupOpen={isPopupOpen}
          geo={geo}
          onLocationChange={this.handleLocationChange}
          onRegionSelect={refreshRegions}
          onCloseButtonClick={this.handlePopupClose}
          fetchRegionsCities={fetchRegionsCities}
          isMobileVersion
        />
      </>
    );
  }

  private handlePopupOpen = () => {
    const { selectedCity, selectedRegion } = this.props.geo;
    const region = selectedCity || selectedRegion;
    if (region) {
      this.props.refreshRegions(
        {
          ...region,
          id: region.regionId || region.id,
        },
        true,
      );
    }
    this.setState({ isPopupOpen: true });
  };

  private handlePopupClose = () => this.setState({ isPopupOpen: false });

  private handleLocationChange = (region: ICity, isDefaultCity = false) => {
    const { changeRegion } = this.props;
    this.setState({ isPopupOpen: false });
    changeRegion(isDefaultCity ? { ...region, id: DEFAULT_CITY_REGIONS_IDS[region.id] || region.id } : region);
  };
}
